import React, { useRef, useState } from "react";
import * as styles from "./styles.mod.scss";
import Truck from "assets/images/truck.svg";
import locale from "locales";
import getImagePath from "helpers/get-image-path";
import { Overlay, Tooltip } from "react-bootstrap";

const ProductShippingDetails = (props) => {
  const { miniIcons, pdpTemplate, enhancedPDP, content, inStock, restockDate } = props;
  const COUNTRY = process.env.GATSBY_COUNTRY;
  const target = useRef(null);
  const [show, setShow] = useState(false);
  const langInfo = locale.products;

  const shippingEtaColor = restockDate
    ? "#E68B51"
    : (inStock ? "#02b151" : "#c10000");
  const tooltipMessage = inStock
    ? (langInfo.tooltipMessage.inStock)
    : "";

  const shippingEta = restockDate
    ? `Dieses Produkt ist bestellbar, wird aber erst ${restockDate} geliefert `
    : (inStock ? langInfo.shippingEta.inStock : langInfo.shippingEta.outOfStock);

  return (
    <div className={styles.freeReturns}>
      <div className={styles.frContent}>
        <img src={Truck} alt={locale.altText.truckIcon} />
        <p className={styles.shippingEta}>
          {
            shippingEta && (
              <span
                className={styles.tooltipInfo}
                ref={target}
                onMouseEnter={() => setShow(true)}
                onMouseOut={() => setShow(false)}
                style={{ color: shippingEtaColor, }}

              >
                {shippingEta}
                {
                  (COUNTRY !== "uk" && COUNTRY !== "fr" && pdpTemplate !== "accessoires" && inStock && !restockDate ) && (
                    <span className={styles.questionMark}>
                      ?
                    </span>
                  )
                }
              </span>
            )
          }{locale?.products?.freeReturns}
        </p>
      </div>
      {inStock && tooltipMessage && !restockDate && (
        <Overlay target={target.current} show={show} placement="bottom">
          {(props) => <Tooltip id="overlay-example" {...props}>{tooltipMessage}</Tooltip>}
        </Overlay>
      )}

      {miniIcons?.freeShipping &&
        <div className={styles.frContent}>
          {content?.iconFreeShippingMessage &&
            <img src={getImagePath(content?.iconFreeShippingMessage)} alt={content?.iconFreeShippingMessage?.alt} />}
          <p className={styles.shippingEta}>{miniIcons?.freeShipping}</p>
        </div>
      }

      <div className={styles.deliveryOptions}>
        {enhancedPDP?.deliveryOptions?.map((data, i) =>
          (<div className={styles.doContent} key={i}>
            <img src={getImagePath(data?.icon)} alt={data?.icon} />
            {data?.underlinedText && <p style={{ borderBottom: "1px solid #F78505" }} className={styles.shippingEta}>{data?.underlinedText}</p>}
            <p className={styles.shippingEta}>{data?.text}</p>
          </div>
          ))}
      </div>
    </div>
  );
};

export default ProductShippingDetails;